// extracted by mini-css-extract-plugin
module.exports = {"instructorLogo":"style__instructorLogo__KqEIA","textLogo":"style__textLogo__uViJr"};